import React, { FC } from 'react'
import {Container, StyledToggle, DotPoint} from './styles'
import Label from '../label'

type ToggleProps = {
  title:string,
  value:boolean,
  onChange:() => void,
  customStyles?:any,
  toolTip?:boolean,
  tooltipText?:string,
  test_id?:string,
  disabled?:boolean,
}

const Toggle:FC<ToggleProps> = (props) => {
  const {
    title,
    value,
    onChange,
    customStyles,
    tooltipText,
    toolTip=false,
    test_id,
    disabled,
  } = props

  return(
    <Container customStyles={customStyles} $hasTitle={title.length > 0}>
      <StyledToggle
        type="button"
        role="switch"
        aria-checked={value}
        aria-label={title || undefined}
        data-test-id={test_id}
        $noMargin={title.length === 0}
        onClick={onChange}
        $active={value}
        disabled={disabled}
      >
        <DotPoint $active={value} />
      </StyledToggle>
      {title.length === 0 ? null : 
        <Label margin={''} tooltipText={tooltipText} toolTip={toolTip}title={title}/>
      }
    </Container>
  )
}


export default Toggle
